// extracted by mini-css-extract-plugin
export default {"paginationSizeDropdown":"TableFooter_paginationSizeDropdown__elnZV","sizeActive":"TableFooter_sizeActive__I9Jci","pageSizeWrapper":"TableFooter_pageSizeWrapper__tDgwt"};